// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  width: 260px;
  background: #fff;
  border: 1px solid #f5f5f5;
  box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  font-size: 12px;
  max-width: 260px;
  padding: 10px;
  position: absolute;
  z-index: 10;
  margin-left: 25px;
  transform: translateY(-50%);
  text-align: left;
}

.tooltip-title {
  font-size: 14px;
  font-weight: bold;
}

.tooltip-subtitle {
  line-height: 20px;
}

.media-info {
  border-left: solid 4px;
  padding-left: 10px;
  padding-top: 0px;
}

.tooltip-row {
  display: flex;
  justify-content: flex-start;
  line-height: 20px;
  font-size: 12px;
}

.tooltip-row span {
  margin-right: 5px;
}

.tooltip-separator {
  width: 100%;
  background-color: #c9c7c7;
  height: 1px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.end {
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Tooltip/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".tooltip-container {\n  width: 260px;\n  background: #fff;\n  border: 1px solid #f5f5f5;\n  box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);\n  font-size: 12px;\n  max-width: 260px;\n  padding: 10px;\n  position: absolute;\n  z-index: 10;\n  margin-left: 25px;\n  transform: translateY(-50%);\n  text-align: left;\n}\n\n.tooltip-title {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.tooltip-subtitle {\n  line-height: 20px;\n}\n\n.media-info {\n  border-left: solid 4px;\n  padding-left: 10px;\n  padding-top: 0px;\n}\n\n.tooltip-row {\n  display: flex;\n  justify-content: flex-start;\n  line-height: 20px;\n  font-size: 12px;\n}\n\n.tooltip-row span {\n  margin-right: 5px;\n}\n\n.tooltip-separator {\n  width: 100%;\n  background-color: #c9c7c7;\n  height: 1px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.end {\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
